import MagasinI18n from './Magasin.i18n.js';
import pHeader from '@/components/Header/Header.vue'
import pFooter from '@/components/Footer/Footer.vue'
import pNav from '@/components/Nav/Nav.vue'
import bandeau from '@/components/Bandeau/Bandeau.vue'
import MenuBurger from '../../components/MenuBurger/MenuBurger.vue';

import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex'

export default {

  components: {
    pHeader,
    pFooter,
    pNav,
    bandeau,
    MenuBurger
  },

  props: {},

  data() {
    return {
      clientIp: '',
      show: true
    };
  },
  computed: {
    ...mapGetters(['categories', 'loggingLoading', 'commandeUploading', 'userUpdating']),
    routeName() {
      return this.$route.name
    },
    isLoading() {
      return this.loggingLoading || this.commandeUploading || this.userUpdating
    }
  },

  watch: {},

  methods: {
    ...mapActions(['getCategories', 'getUser']),
    ...mapMutations(['setCart'])
  },

  mounted() {
    this.getCategories().then(res => {
      // Get the cart stored in localStorage
      const cart = localStorage.getItem('cart')
      if (cart) {
        const cartJson = JSON.parse(cart)
        this.setCart(cartJson)
      }
      if (this.$route.name !== 'confirmRegister') {
        this.getUser().then(res => {

        }).catch(err => {
          console.log(err)
        })
      }

    }).catch(err => {
      console.log(err)
    }).catch(err => {
      console.log(err)
    })
  },

  i18n: MagasinI18n,

};